import { dialog, InfiniteScroll, Progress } from "../../../../../nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import Search from "../../../../../components/Search";
import BaseListPage from "../../../../../base/BaseListPage";
import { toDisplayCase } from "../../../../../nq-component";
import NavBar from "../../../../../components/navbar";
import Table from "../../../../../components/Table";
import CollapseView from "./components/CollapseView";
import DialogModal from "../../../../../components/Dialog";
import UpcomingRequestPresenter from "./UpcomingRequestPresenter";
import RightSidebar from "../../../../../components/RightSidebar";
import PageHeader from "../../../../../components/PageHeader";
import DialogDispatch from "./components/DialogDispatch";
import DialogDisapproved from "./components/DialogDisapproved";

class UpcomingRequestPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new UpcomingRequestPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      selected: [],
      loading: true,
      total: 0,
      count: 0,
      range: "",
      showMobileFilters: false,
    };
  }

  getCollectionName() {
    return "stock_requests";
  }

  closeDialog() {
    dialog.close();
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  onClickAdd() {
    this.presenter.onClickAdd();
  }

  onClickEdit(index) {
    this.presenter.onClickEdit(index);
  }

  onClickDelete(index) {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-exclamation-octagon-fill"
          iconColor="red"
          title="Confirm Deletion"
          message="This will remove the selected data from the system. Are you sure want to continue?"
          isCancelButton={true}
          onSubmit={() => this.presenter.onClickDelete(index)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickApproveRequest(index) {
    this.presenter.onClickApproveRequest(index);
  }

  onClickDispatchRequest(index) {
    dialog.fire({
      html: (
        <DialogDispatch
          index={index}
          onSubmitDispatch={(index, estimatedDateTime) =>
            this.presenter.onDispatchSubmit(index, estimatedDateTime)
          }
          onSubmit={() => dialog.close()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickAction(index) {
    dialog.fire({
      html: (
        <>
          <DialogDisapproved
            index={index}
            onSubmit={(index, reason) =>
              this.presenter.onDisapproveSubmit(index, reason)
            }
          />
          {/* <div className="p-2">
            <p className="fw-bold mb-1">Disapprove</p>
            <hr />
            <p className="mb-2">
              Enter the reason why you want to disapprove this request.
            </p>
            <textarea
              className="form-control"
              rows="4"
              onChange={(e) => {
                reason = e.target.value;
              }}
            ></textarea>
            <div className="text-center mt-3">
              <button
                className="btn w-25 me-2"
                style={{ backgroundColor: "#d1d1d1" }}
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                className="btn w-25 text-white"
                style={{ backgroundColor: "#e74c3c" }}
                onClick={() => {
                  if (!reason.trim()) {
                    dialog.fire({
                      html: (
                        <DialogModal
                          icon="bi bi-question-octagon-fill"
                          iconColor="#e74c3c"
                          title="Error"
                          message="Please provide a reason."
                          isCancelButton={false}
                          onSubmit={() => dialog.close()}
                          onClose={() => dialog.close()}
                        />
                      ),
                      footer: false,
                    });
                    return;
                  }

                  dialog.close();

                  setTimeout(() => {
                    dialog.fire({
                      html: (
                        <DialogModal
                          icon="bi bi-question-octagon-fill"
                          iconColor="#82c14a"
                          title="Confirm Disapproval"
                          message="Are you sure you want to disapprove this request?"
                          isCancelButton={true}
                          onSubmit={() =>
                            this.presenter.onDisapproveSubmit(index, reason)
                          }
                          onClose={() => dialog.close()}
                        />
                      ),
                      footer: false,
                    });
                  }, 200);
                }}
              >
                Disapprove
              </button>
            </div>
          </div> */}
        </>
      ),
      footer: false,
    });
  }

  onClickApproveReceive(index) {
    // this.presenter.onClickApproveReceive(index);
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure you want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.onClickApproveReceive(index)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onApprovePartialRequest(index) {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure you want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.onApprovePartialRequest(index)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onApproveReconcile(index) {
    this.presenter.onApproveReconcile(index);
  }

  onCollapse(index) {
    const stock = this.state.objects[index];
    return (
      <CollapseView
        stock={stock}
        onApproveReceive={() => this.onClickApproveReceive(index)}
        onApproveRequest={() => this.onClickApproveRequest(index)}
        onApprovePartialRequest={() => this.onApprovePartialRequest(index)}
        onApproveReconcile={() => this.onApproveReconcile(index)}
        onDispatchRequest={() => this.onClickDispatchRequest(index)}
        onEdit={() => this.onClickEdit(index)}
        onClickAction={() => this.onClickAction(index)}
      />
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, loading } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <NavBar />
        <RightSidebar
          isVisible={this.state.showMobileFilters}
          onClose={() => this.setState({ showMobileFilters: false })}
          onDateChange={this.onChangeDate.bind(this)}
          range={this.state.range}
        />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!loading && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <PageHeader
                  title={
                    "Upcoming Request" ||
                    toDisplayCase(this.getCollectionName())
                  }
                  subtitle={schema.description}
                  icon="bi bi-boxes"
                />
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <Search
                  schemas={this.getSchemas()}
                  className="mt-3"
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
                <div className="text-nowrap mt-3">
                  <i
                    className="bi bi-filter fs-1"
                    onClick={() => this.setState({ showMobileFilters: true })}
                    style={{ color: "#83c14a" }}
                  ></i>
                </div>
              </div>
              <Table
                fields={schema.fields}
                objects={objects}
                selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "acl",
                    "password",
                    "storeId",
                    "requestNumber",
                    "requestedBy",
                    "remarks",
                    "sourceLocation",
                    "reconcileRemarks",
                    "attachment",
                  ],
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onCollapse={this.onCollapse.bind(this)}
                //  progress={progress}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3"
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(UpcomingRequestPage);
